/**
 * =========================================================================================
 * Settings - Header
 * =========================================================================================
 *
 */

import React from 'react';
// Icons & Framework
import * as Icon from 'ubs-icons';
import {COLOR} from "ubs-framework/v2/common/constant";

const AppHeader = React.memo(({desc, tooltipText, title, confirm, submitShift, children, totalRecords, padding, previousBtn, prevClick, modalButton, showTooltip = true}) => {
    return (
        <React.Fragment>
            <div className={`u_settings-header ${padding ? padding : 'u_p-15'}`} id="u_settings-header">

                <div className={`u_settings-header-title ${(!desc || modalButton) ? 'u_flex u_align-center' : ''}`}>
                    {
                        totalRecords ?
                            <h5 className={`${desc && 'u_mb-5'}`}>{totalRecords} <span>{title}</span></h5>
                            :
                            <div className="u_flex u_align-center">
                                {previousBtn &&
                                <span className="u_icon-rollover u_header-breadcrumb-arrow u_mr-10 u_cp" onClick={e => prevClick(e)}>
                                        <Icon.RightArrow size={16} fill={COLOR.u_blue}/>
                                    </span>
                                }
                                <h5 className={`${desc && 'u_mb-5'}`}>{title}</h5>
                            </div>
                    }
                    {desc !== '' && <p>{desc}</p>}

                    {modalButton && modalButton}
                </div>

                <div className="u_settings-header-list">

                    <div className="u_flex u_align-center u_content-end">
                        {children}
                    </div>

                </div>

            </div>

        </React.Fragment>
    );
});

export default AppHeader; 